import { render, staticRenderFns } from "./ImportPlans.vue?vue&type=template&id=0a9d7129&scoped=true&"
import script from "./ImportPlans.vue?vue&type=script&lang=ts&"
export * from "./ImportPlans.vue?vue&type=script&lang=ts&"
import style0 from "./ImportPlans.vue?vue&type=style&index=0&id=0a9d7129&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9d7129",
  null
  
)

export default component.exports